const useMatrixPieChartData = (reportData) => {
  const weightsMap = reportData.weights.reduce(
    (map, weight, index) => ({
      ...map,
      [weight.id]: { ...weight, colorIndex: index },
    }),
    {}
  );

  const chartData = reportData.options.reduce(
    (data, option) => [
      ...data,
      {
        label: option.label,
        values: option.values.map((value) => ({
          ...value,
          ...weightsMap[value.weightId],
        })),
      },
    ],
    []
  );

  return chartData;
};

export default useMatrixPieChartData;
